import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import CustomDropdown from './CustomDropdown';
import { FormValues } from './types';
import IntlStore from "stories/IntlStore";

interface Option {
  value: string | number;
  label: string;
}

interface FormSelectProps {
  id?: string;
  name: string;
  label?: string;
  placeholder?: string;
  items: Option[];
  initialValue?: string | number | null;
  onChange?: (option: Option) => void;
  addLabelHandler?: () => void;
  itemTemplate?: (option: Option) => React.ReactNode;
  setSelectedlabel: (selectedlabel:string)=>void
  onHide: () => void;
  values:FormValues
  setCreate:(create:string)=>void
}

const FormSelect: React.FC<FormSelectProps> = ({
  id,
  name,
  label,
  placeholder = IntlStore.intl.formatMessage({
    id: "NewRelease.ReleaseInfo.Select",
    defaultMessage: "Select..."
  }),
  items,
  initialValue = null,
  onChange,
  addLabelHandler,
  itemTemplate,
  setSelectedlabel,
  onHide,
  values,
  setCreate
}) => {

  const initialSelected = items.find((item) => item.value === initialValue) || null;
  const [selected, setSelected] = useState<Option | null>(initialSelected);

  useEffect(() => {
    const newSelected = items.find((item) => item.value === initialValue) || null;
    setSelected(newSelected);
  }, [initialValue, items]);

  const handleChange = (option: Option) => {
    setSelected(option);
    onChange && onChange(option);
  };

  return (
    <Container id={id}>
      {label && (
        <StyledLabel htmlFor={name}>
          {label} <RequiredMark>*</RequiredMark>
        </StyledLabel>
      )}
      <CustomDropdown
        setCreate={setCreate}
        options={items}
        placeholder={placeholder}
        value={selected}
        onChange={handleChange}
        name={name}
        itemTemplate={itemTemplate}
        addLabelHandler={addLabelHandler}
        setSelectedlabel={setSelectedlabel}
        onHide={onHide}
        values={values}
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  font-family: Arial, sans-serif;
`
const StyledLabel = styled.label`
  width: 100%;
  display: block;
  margin-bottom: 4px;
  font-weight: 600;
`
const RequiredMark = styled.span`
  color: #6777FF;
`;
export default FormSelect;
